import React from 'react';
import { createPortal } from 'react-dom';

interface Props {
  hideLoader?: boolean;
}

export default class FsLoader extends React.Component<Props> {
  constructor(props: any) {
    super(props);
    // this.setAppCursorStyle();
  }

  // componentDidUpdate(prevProps: any) {
  //   const { hideLoader } = this.props;
  //   if (prevProps.hideLoader !== hideLoader) this.setAppCursorStyle();
  // }

  componentWillUnmount() {
    const root = document.getElementById('root');
    if (root) {
      root.style.cursor = 'default';
    }
  }

  setAppCursorStyle = () => {
    const { hideLoader = false } = this.props;
    const root = document.getElementById('root');
    if (root) {
      root.style.cursor = hideLoader ? 'default' : 'progress';
    }
  };

  render() {
    const { hideLoader = false } = this.props;
    const loader = (
      <div className="ajax-loader">
        <div className="ajax-animator"></div>
      </div>
    );
    return (
      <>
        {!hideLoader &&
          (typeof document !== 'undefined' ? createPortal(loader, document.body) : loader)}
      </>
    );
  }
}
